<template>
  <div class="legs-list">
    <div
      v-for="(leg, index) in legs"
      :key="index"
      class="leg-card"
      :style="{ borderLeftColor: getLegColor(index) }"
    >
      <div class="leg-header">
        <h4 class="leg-metrics">
          <span>{{ formatDistance(leg.distance_km) }}</span>
          <span class="separator">•</span>
          <span>{{ formatDuration(leg.time_minutes) }}</span>
        </h4>
      </div>

      <div class="leg-body">
        <div class="timeline-visual">
          <div class="marker-wrapper">
            <span
              class="marker-dot"
              :style="{ backgroundColor: getLegColor(index) }"
            >
              {{ leg.fromLabel }}
            </span>
          </div>
          <div
            class="timeline-line"
            :style="{ borderColor: getLegColor(index) }"
          ></div>
          <div class="marker-wrapper">
            <span
              class="marker-dot"
              :style="{ backgroundColor: getLegColor(index) }"
            >
              {{ leg.toLabel }}
            </span>
          </div>
        </div>

        <div class="timeline-content">
          <div class="point-info">
            <div class="point-address">{{ leg.fromAddress || "—" }}</div>
          </div>
          <div class="content-spacer"></div>
          <div class="point-info">
            <div class="point-address">{{ leg.toAddress || "—" }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LEG_COLORS } from "@/utils/mapUtils";

export default {
  name: "RouteLegsInfo",

  props: {
    legs: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getLegColor(index) {
      return LEG_COLORS[index % LEG_COLORS.length];
    },

    formatDistance(km) {
      if (km == null) return "—";
      return `${Number(km).toFixed(1)} км`;
    },

    formatDuration(minutes) {
      if (minutes == null) return "—";
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      if (hours === 0) return `${mins} мин`;
      return `${hours} ч ${mins} мин`;
    },
  },
};
</script>

<style scoped>
.legs-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.leg-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  padding: 15px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-left-width: 5px;
}

.leg-header {
  margin-bottom: 15px;
}

.leg-metrics {
  color: #666;
  display: flex;
  align-items: center;
}

.separator {
  margin: 0 5px;
}

.leg-body {
  display: flex;
  gap: 15px;
}

.timeline-visual {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 28px;
  flex-shrink: 0;
}

.marker-wrapper {
  height: 28px;
  width: 28px;
  flex-shrink: 0;
}

.marker-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-line {
  width: 2px;
  flex-grow: 1;
  background: transparent;
  border-left-style: dashed;
  border-left-width: 2px;
  opacity: 0.5;
  margin: 4px 0;
}

.timeline-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.point-info {
  display: flex;
  flex-direction: column;
  padding-top: 2px;
}

.point-address {
  font-size: 14px;
  line-height: 1.4;
}

.content-spacer {
  height: 25px;
  flex-shrink: 0;
}
</style>
